import { Pipe, PipeTransform } from '@angular/core';
import * as utils from '@app/shared/utils';

@Pipe({
  name: '_cnpj',
  pure: true,
})
export class CnpjPipe implements PipeTransform {
  public transform(value: string): any {
    if (!value) {
      return;
    }
    return utils.formatCnpj(value);
  }
}
